// This is for the custom toastr so that all the property appy to toastr  from one place

import toastr from 'toastr';

export class CustomToastrAction
{
    constructor()
    {
        this.toastr = toastr;
        this.defaultOption =  {
                                preventDuplicates: true, 
                                timeOut: "4000"
                              }
    }

    setNormalToastr(message, type, options)
    {
        this.toastr.remove();
        this.toastr.options = (typeof options !== 'undefined') ?  options : this.defaultOption;
      
        switch(type)
        {
            case 'warning': this.toastr.warning(message);
                            break;
            case 'error'  : this.toastr.error(message);
                            break;
            default       : this.toastr.success(message);
                            break;

        }
    }

    removeToastr(){
        this.toastr.remove();
    }

    clearToastr(){
        this.toastr.clear();
    }
    
}